import { getPageSetFromPath } from "@pageDefinitions/pageSets";
import { findEntryPointLocation } from "src/pageDefinitions/actions/survey/util";
import getStore from "src/utils/redux/store";
import { gotoPage } from "./pageSet";
import { getHistory } from "../components/PageSetRouter";
import { getMedRecommendedPlanTier } from "src/components/med/planInformation/utils";
import { MED_SKU } from "src/utils/medEligibility";
import goto from ".";

const medSkuEntryPoints = {
  [MED_SKU.ORALS_METFORMIN]: "medOralsPlan",
  [MED_SKU.COMPOUNDED]: "medCompoundedPlan",
  [MED_SKU.BRANDED]: "medBrandedPlan",
};

export default {
  async navigateToPlanRevealPage() {
    const store = getStore();
    const history = getHistory();
    const pageSet = await getPageSetFromPath(
      window.location.pathname,
      getStore().getState()
    );

    const recommendedMedTier = getMedRecommendedPlanTier();
    const entryPoint = medSkuEntryPoints[recommendedMedTier];
    if (!entryPoint) {
      return goto.bail(
        "mainSurvey",
        [],
        "No entry point found for med tier payment results"
      );
    }

    const entryPointLocation = findEntryPointLocation(pageSet, entryPoint);
    return gotoPage(pageSet, { store, history }, false, entryPointLocation);
  },
};
